export default __webpack_public_path__ + "static/media/image14.bb529c88.svg";